export enum ActionType {
  UserCommentAction = "UserCommentAction",
  UserCreatedContactPerson = "UserCreatedContactPerson",
  UserCreatedBookingGroupAction = "UserCreatedBookingGroupAction",
  UserMassEmailAction = "UserMassEmailAction",
  UserMetInPersonAction = "UserMetInPersonAction",
  UserSMSAction = "UserSMSAction",
  UserChatAction = "UserChatAction",
  UserEmailAction = "UserEmailAction",
  UserUpdatedCustomer = "UserUpdatedCustomer",
  CompleteTodo = "CompleteTodo",
  ConsultantFormSubmit = "ConsultantFormSubmit",
  ConsultantProfileAccess = "ConsultantProfileAccess",
  CreateTodo = "CreateTodo",
  DownloadConsultantPresentation = "DownloadConsultantPresentation",
  SubmitConsultantReference = "SubmitConsultantReference",
  UpdateConsultantAvailability = "UpdateConsultantAvailability",
  UserSetQualityItemStatusApproved = "UserSetQualityItemStatusApproved",
  UserClearedQualityItemStatus = "UserClearedQualityItemStatus"
}
